import { render, staticRenderFns } from "./ideas.vue?vue&type=template&id=27fa8295&scoped=true"
import script from "./ideas.vue?vue&type=script&lang=js"
export * from "./ideas.vue?vue&type=script&lang=js"
import style0 from "./ideas.vue?vue&type=style&index=0&id=27fa8295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa8295",
  null
  
)

export default component.exports